import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import ImprintScanStatusWidget from './ImprintScanStatusWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
        salesOrder: selector.selectSalesOrder(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImprintScanStatusWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/ImprintScanStatusWidgetContainer.js